import * as React from 'react';
import { Section } from 'features/page-navigation/types';
import { Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getIsBot } from 'common/selectors';

export const DATA_QA_OUT_OF_STOCK_MESSAGE = 'out-of-stock-sticky_mf-pdp';

export const OutOfStockMessage: React.FC<{ onSectionActivated: (section: Section) => void }> = ({
  onSectionActivated,
}) => {
  const { t } = useTranslation();
  const text = t('product-info.availability.out-of-stock');

  if (useSelector(getIsBot)) return null;

  return (
    <Typography
      onClick={() => onSectionActivated({ title: text, href: '' })}
      data-qa={DATA_QA_OUT_OF_STOCK_MESSAGE}
      color="attention-dark"
      size="caption_accent"
      variant="minor"
    >
      {text}
    </Typography>
  );
};
